"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfChatRequestDto = instanceOfChatRequestDto;
exports.ChatRequestDtoFromJSON = ChatRequestDtoFromJSON;
exports.ChatRequestDtoFromJSONTyped = ChatRequestDtoFromJSONTyped;
exports.ChatRequestDtoToJSON = ChatRequestDtoToJSON;
exports.ChatRequestDtoToJSONTyped = ChatRequestDtoToJSONTyped;
/**
 * Check if a given object implements the ChatRequestDto interface.
 */
function instanceOfChatRequestDto(value) {
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function ChatRequestDtoFromJSON(json) {
    return ChatRequestDtoFromJSONTyped(json, false);
}
function ChatRequestDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'message': json['message'],
        'conversationId': json['conversationId'] == null ? undefined : json['conversationId'],
        'model': json['model'] == null ? undefined : json['model'],
        'systemPrompt': json['systemPrompt'] == null ? undefined : json['systemPrompt'],
        'temperature': json['temperature'] == null ? undefined : json['temperature'],
        'maxTurns': json['maxTurns'] == null ? undefined : json['maxTurns'],
    };
}
function ChatRequestDtoToJSON(json) {
    return ChatRequestDtoToJSONTyped(json, false);
}
function ChatRequestDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'message': value['message'],
        'conversationId': value['conversationId'],
        'model': value['model'],
        'systemPrompt': value['systemPrompt'],
        'temperature': value['temperature'],
        'maxTurns': value['maxTurns'],
    };
}
